import { render, staticRenderFns } from "./aboutBrief.vue?vue&type=template&id=a513f498&scoped=true&"
import script from "./aboutBrief.vue?vue&type=script&lang=js&"
export * from "./aboutBrief.vue?vue&type=script&lang=js&"
import style0 from "./aboutBrief.vue?vue&type=style&index=0&id=a513f498&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a513f498",
  null
  
)

export default component.exports